<template>
  <div class="contentPadding">
    <a-form layout="inline">
      <a-form-item label="参数名称">
        <a-input
          placeholder="请输入参数名称"
          v-model:value="listQuery.paramKey"
          allow-clear
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 20 }">
        <a-button
          type="primary"
          @click="onSearch"
          v-if="isShowBtn('sys:config:info')"
        >
          查询
        </a-button>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 15 }">
        <a-button style="margin-left: 10px" @click="onReset"> 重置 </a-button>
      </a-form-item>
    </a-form>
    <a-row class="buttonGroup">
      <a-button
        type="primary"
        class="btnMargin"
        @click="toAdd"
        v-if="isShowBtn('sys:config:save')"
      >
        <PlusOutlined />新增
      </a-button>
      <a-button
        class="btnMargin"
        v-if="isShowBtn('sys:config:delete')"
        @click="handleDelAll"
      >
        批量删除
      </a-button>
    </a-row>
    <a-table
      :row-selection="rowSelection"
      :data-source="articlelist"
      row-key="id"
      :pagination="pagination"
      @change="changeTable"
    >
      <a-table-column
        key="paramKey"
        title="参数名"
        data-index="paramKey"
        align="center"
      />
      <a-table-column
        key="paramValue"
        title="参数值"
        data-index="paramValue"
        align="center"
        :ellipsis="true"
      />
      <a-table-column
        key="remark"
        title="备注"
        data-index="remark"
        align="center"
      />
      <a-table-column key="action" title="操作" align="center" :width="300">
        <template v-slot="scope">
          <span>
            <a-button
              type="link"
              @click="handleEdit(scope.record)"
              v-if="isShowBtn('sys:config:update')"
            >
              编辑
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <!-- 添加、修改modal -->
    <a-modal
      :title="title"
      v-model:visible="showModal"
      :maskClosable="false"
      :footer="null"
      :centered="true"
      width="40%"
    >
      <a-form
        :labelCol="{ span: 3, offset: 0 }"
        :wrapperCol="{ span: 20, offset: 0 }"
        ref="addForm"
        :model="rowData"
        :rules="rules"
      >
        <a-form-item label="参数名" name="paramKey">
          <a-input v-model:value="rowData.paramKey" />
        </a-form-item>
        <a-form-item label="参数值" name="paramValue">
          <!-- <a-input v-model:value="rowData.paramValue" /> -->
          <a-textarea
            v-model:value="rowData.paramValue"
            :autosize="{ minRows: 2, maxRows: 6 }"
            :allowClear="true"
          />
        </a-form-item>
        <a-form-item label="备注" name="remark">
          <a-textarea
            v-model:value="rowData.remark"
            :autosize="{ minRows: 2, maxRows: 6 }"
            :allowClear="true"
            :showCount="true"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 9 }">
          <a-button type="primary" @click="handleSave">
            保存
          </a-button>
          <a-button style="margin-left: 10px;" @click="handleCancle">
            取消
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { createVNode, nextTick } from "vue";
import { message, Modal, notification } from "ant-design-vue";
import { isShowBtn } from "../../../until/tool";

export default {
  name: "",
  props: {},
  data() {
    const validateParentId = async (rule, value) => {
      if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(value)) {
        return Promise.reject("只能以字母开头，并且只允许输入字母与数字");
      } else {
        return Promise.resolve();
      }
    };
    return {
      rules: {
        paramKey: [
          { required: true, validator: validateParentId, trigger: "blur" }
        ],
        paramValue: [
          { required: true, message: "请填写参数值", trigger: "blur" }
        ]
      },
      loading: false,
      showModal: false,
      articlelist: [],
      selectRowIds: [],
      title: "",
      rowData: {
        id: "",
        paramKey: "",
        paramValue: "",
        remark: ""
      },
      listQuery: {
        paramKey: "",
        pageSize: 10,
        pageIndex: 1
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "30"], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      }
    };
  },
  computed: {
    rowSelection() {
      return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRowIds = selectedRowKeys;
        }
      };
    }
  },
  watch: {},
  methods: {
    isShowBtn,
    getList() {
      this.loading = true;
      this.$store
        .dispatch("QueryPageConfig", this.listQuery)
        .then(res => {
          if (res.code === 0) {
            if (
              res.page.currPage > res.page.totalPage &&
              res.page.totalPage !== 0
            ) {
              this.listQuery.pageIndex = res.page.totalPage;
              this.getList();
            } else {
              this.listQuery.pageIndex = res.page.currPage;
            }
            // this.data = res.page.list;
            this.articlelist = res.page.list;
            this.listQuery.pageSize = res.page.pageSize;
            this.pagination.current = res.page.currPage;
            this.pagination.pageSize = res.page.pageSize;
            this.pagination.total = res.page.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            // this.$message.error(res.msg);
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 分页、排序、筛选变化时触发
    changeTable(pagination, filters, sorter) {
      this.listQuery.pageIndex = pagination.current;
      this.listQuery.pageSize = pagination.pageSize;
      this.getList();
    },
    toAdd() {
      this.showModal = true;
      this.title = "添加信息";
      this.temp();
    },
    temp() {
      this.rowData = {
        id: "",
        paramKey: "",
        paramValue: "",
        remark: ""
      };
    },
    handleSave() {
      let message = "";
      let funStr = "";
      if (this.rowData.id !== "") {
        message = "修改成功";
        funStr = "UpdateConfig";
      } else {
        message = "保存成功";
        funStr = "SaveConfig";
      }
      const that = this;
      this.$refs.addForm
        .validate()
        .then(() => {
          that.$store
            .dispatch(funStr, this.rowData)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: message
                });
                that.showModal = false;
                that.temp();
                that.getList();
              } else {
                that.$handleErr(res);
              }
            })
            .catch(err => {
              that.$handleErr(err);
            });
        })
        .catch(error => {
          return false;
        });
    },
    onSearch() {
      this.getList();
    },
    onReset() {
      this.listQuery.paramKey = "";
    },
    handleEdit(data) {
      this.showModal = true;
      this.title = "修改信息";
      this.$store
        .dispatch("SelectInfoConfig", { id: data.id })
        .then(res => {
          if (res.code === 0) {
            this.rowData = res.config;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    handleDelAll() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      if (this.selectRowIds.length === 0) {
        this.$message.warning("请先选择数据，在进行批量删除操作");
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认批量删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self.$store
            .dispatch("DeleteBatchConfig", self.selectRowIds)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.selectRowIds = "";
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        },
        onCancel() {}
      });
    },
    handleCancle() {
      this.showModal = false;
      this.temp();
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  mounted() {
    this.getList();
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  beforeUnmount() {},
  components: {
    PlusOutlined,
    // eslint-disable-next-line vue/no-unused-components
    ExclamationCircleOutlined
  },
  filters: {}
};
</script>
<style lang="scss" scoped>
.btnMargin {
  margin-right: 10px;
}
</style>
